import {
  TOGGLE_VIDEO
} from '../actions/video'

const videoReducer = (state = null, action) => {
  switch (action.type) {
    case TOGGLE_VIDEO: {
      return {
        ...state,
        isPlaying: !state.isPlaying,
        videos: state.videos.map((video) => {
          if (video.id === action.id) {
            return {
              id: action.id,
              isOpen: !video.isOpen
            }
          }
          return video
        })
      }
    }
    default:
      return state
  }
}

export default videoReducer



// WEBPACK FOOTER //
// ./src/shared/reducers/video.js